export default __webpack_public_path__ + "static/media/about_me.71944f53.png";